import { z } from "zod";

const salesCategoryEnum = z.enum([
  "전체",
  "개인",
  "그룹",
  "회원권",
  "옵션",
  "기타",
]);

const optionalNumberOrNull = z.preprocess(
  (val) => {
    if (val === undefined || val === null || val === "") {
      return null;
    }
    return val;
  },
  z.union([
    // 1. null 값은 유효한 것으로 인정합니다.
    z.null(),
    // 2. 또는 0 이상의 숫자여야 합니다.
    z.coerce
      .number({ invalid_type_error: "숫자를 입력해주세요." })
      .min(0, "0 이상의 값을 입력해주세요."),
  ])
);

export const BepSalesItemSchema = z.object({
  category: salesCategoryEnum,
  bep: optionalNumberOrNull,
  targetSales: optionalNumberOrNull,
});

export const BepSalesFormSchema = z.object({
  items: z.array(BepSalesItemSchema),
});

export type BepSalesFormValues = z.infer<typeof BepSalesFormSchema>;
export type SalesCategory = z.infer<typeof salesCategoryEnum>;
